// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_array from "@rescript/std/lib/es6/js_array.js";
import * as GraphQL_PPX from "@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js";
import * as Gql__Icon__Fragment from "../Icon/Gql__Icon__Fragment.bs.js";
import * as Gql__Image__Fragment from "../Image/Gql__Image__Fragment.bs.js";

var Raw = {};

var query = ((frag_0, frag_1) => require("@apollo/client").gql`
  fragment StatsTilesBlock on EnvironmentalImpactsBlockContentType   {
    __typename
    title  {
      __typename
      value
    }
    description  {
      __typename
      value
    }
    environmental_impact_cards  {
      __typename
      value  {
        __typename
        ...on EnvironmentalImpactCardContentType   {
          __typename
          system  {
            __typename
            id
            codename
          }
          title  {
            __typename
            value
          }
          subtitle  {
            __typename
            value
          }
          text_colour  {
            __typename
            value  {
              __typename
              codename
            }
          }
          icon  {
            __typename
            value  {
              __typename
              ...on IconContentType   {
                ...Icon
              }
            }
          }
          fontawesome_icon_class  {
            __typename
            value
          }
          background_colour  {
            __typename
            value
          }
          background_image  {
            __typename
            value  {
              __typename
              ...on ImageContentType   {
                ...Image
              }
            }
          }
          background_image_mobile  {
            __typename
            value  {
              __typename
              ...on ImageContentType   {
                ...Image
              }
            }
          }
        }
      }
    }
  }
  ${frag_0}
  ${frag_1}
`)(Gql__Icon__Fragment.Icon.query, Gql__Image__Fragment.$$Image.query);

function parse(value) {
  var value$1 = value.title;
  var tmp;
  if (value$1 == null) {
    tmp = undefined;
  } else {
    var value$2 = value$1.value;
    tmp = {
      __typename: value$1.__typename,
      value: !(value$2 == null) ? value$2 : undefined
    };
  }
  var value$3 = value.description;
  var tmp$1;
  if (value$3 == null) {
    tmp$1 = undefined;
  } else {
    var value$4 = value$3.value;
    tmp$1 = {
      __typename: value$3.__typename,
      value: !(value$4 == null) ? value$4 : undefined
    };
  }
  var value$5 = value.environmental_impact_cards;
  var tmp$2;
  if (value$5 == null) {
    tmp$2 = undefined;
  } else {
    var value$6 = value$5.value;
    tmp$2 = {
      __typename: value$5.__typename,
      value: !(value$6 == null) ? Js_array.map((function (value) {
                if (value == null) {
                  return ;
                }
                var typename = value["__typename"];
                var tmp;
                if (typename === "EnvironmentalImpactCardContentType") {
                  var value$1 = value.system;
                  var value$2 = value.title;
                  var tmp$1;
                  if (value$2 == null) {
                    tmp$1 = undefined;
                  } else {
                    var value$3 = value$2.value;
                    tmp$1 = {
                      __typename: value$2.__typename,
                      value: !(value$3 == null) ? value$3 : undefined
                    };
                  }
                  var value$4 = value.subtitle;
                  var tmp$2;
                  if (value$4 == null) {
                    tmp$2 = undefined;
                  } else {
                    var value$5 = value$4.value;
                    tmp$2 = {
                      __typename: value$4.__typename,
                      value: !(value$5 == null) ? value$5 : undefined
                    };
                  }
                  var value$6 = value.text_colour;
                  var tmp$3;
                  if (value$6 == null) {
                    tmp$3 = undefined;
                  } else {
                    var value$7 = value$6.value;
                    tmp$3 = {
                      __typename: value$6.__typename,
                      value: !(value$7 == null) ? Js_array.map((function (value) {
                                if (value == null) {
                                  return ;
                                }
                                var value$1 = value.codename;
                                return {
                                        __typename: value.__typename,
                                        codename: !(value$1 == null) ? value$1 : undefined
                                      };
                              }), value$7) : undefined
                    };
                  }
                  var value$8 = value.icon;
                  var tmp$4;
                  if (value$8 == null) {
                    tmp$4 = undefined;
                  } else {
                    var value$9 = value$8.value;
                    tmp$4 = {
                      __typename: value$8.__typename,
                      value: !(value$9 == null) ? Js_array.map((function (value) {
                                if (value == null) {
                                  return ;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "IconContentType" ? ({
                                      NAME: "IconContentType",
                                      VAL: {
                                        icon: Gql__Icon__Fragment.Icon.verifyArgsAndParse("Icon", value)
                                      }
                                    }) : ({
                                      NAME: "UnspecifiedFragment",
                                      VAL: typename
                                    });
                                return tmp;
                              }), value$9) : undefined
                    };
                  }
                  var value$10 = value.fontawesome_icon_class;
                  var tmp$5;
                  if (value$10 == null) {
                    tmp$5 = undefined;
                  } else {
                    var value$11 = value$10.value;
                    tmp$5 = {
                      __typename: value$10.__typename,
                      value: !(value$11 == null) ? value$11 : undefined
                    };
                  }
                  var value$12 = value.background_colour;
                  var tmp$6;
                  if (value$12 == null) {
                    tmp$6 = undefined;
                  } else {
                    var value$13 = value$12.value;
                    tmp$6 = {
                      __typename: value$12.__typename,
                      value: !(value$13 == null) ? value$13 : undefined
                    };
                  }
                  var value$14 = value.background_image;
                  var tmp$7;
                  if (value$14 == null) {
                    tmp$7 = undefined;
                  } else {
                    var value$15 = value$14.value;
                    tmp$7 = {
                      __typename: value$14.__typename,
                      value: !(value$15 == null) ? Js_array.map((function (value) {
                                if (value == null) {
                                  return ;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? ({
                                      NAME: "ImageContentType",
                                      VAL: {
                                        image: Gql__Image__Fragment.$$Image.verifyArgsAndParse("Image", value)
                                      }
                                    }) : ({
                                      NAME: "UnspecifiedFragment",
                                      VAL: typename
                                    });
                                return tmp;
                              }), value$15) : undefined
                    };
                  }
                  var value$16 = value.background_image_mobile;
                  var tmp$8;
                  if (value$16 == null) {
                    tmp$8 = undefined;
                  } else {
                    var value$17 = value$16.value;
                    tmp$8 = {
                      __typename: value$16.__typename,
                      value: !(value$17 == null) ? Js_array.map((function (value) {
                                if (value == null) {
                                  return ;
                                }
                                var typename = value["__typename"];
                                var tmp = typename === "ImageContentType" ? ({
                                      NAME: "ImageContentType",
                                      VAL: {
                                        image: Gql__Image__Fragment.$$Image.verifyArgsAndParse("Image", value)
                                      }
                                    }) : ({
                                      NAME: "UnspecifiedFragment",
                                      VAL: typename
                                    });
                                return tmp;
                              }), value$17) : undefined
                    };
                  }
                  tmp = {
                    NAME: "EnvironmentalImpactCardContentType",
                    VAL: {
                      __typename: value.__typename,
                      system: {
                        __typename: value$1.__typename,
                        id: value$1.id,
                        codename: value$1.codename
                      },
                      title: tmp$1,
                      subtitle: tmp$2,
                      text_colour: tmp$3,
                      icon: tmp$4,
                      fontawesome_icon_class: tmp$5,
                      background_colour: tmp$6,
                      background_image: tmp$7,
                      background_image_mobile: tmp$8
                    }
                  };
                } else {
                  tmp = {
                    NAME: "UnspecifiedFragment",
                    VAL: typename
                  };
                }
                return tmp;
              }), value$6) : undefined
    };
  }
  return {
          __typename: value.__typename,
          title: tmp,
          description: tmp$1,
          environmental_impact_cards: tmp$2
        };
}

function serialize(value) {
  var value$1 = value.environmental_impact_cards;
  var environmental_impact_cards;
  if (value$1 !== undefined) {
    var value$2 = value$1.value;
    var value$3 = value$2 !== undefined ? Js_array.map((function (value) {
              if (value === undefined) {
                return null;
              }
              if (value.NAME === "UnspecifiedFragment") {
                return {};
              }
              var value$1 = value.VAL;
              var value$2 = value$1.background_image_mobile;
              var background_image_mobile;
              if (value$2 !== undefined) {
                var value$3 = value$2.value;
                var value$4 = value$3 !== undefined ? Js_array.map((function (value) {
                          if (value !== undefined) {
                            if (value.NAME === "UnspecifiedFragment") {
                              return {};
                            } else {
                              return Js_array.reduce(GraphQL_PPX.deepMerge, (function (prim) {
                                            return {};
                                          }), [Gql__Image__Fragment.$$Image.serialize(value.VAL.image)]);
                            }
                          } else {
                            return null;
                          }
                        }), value$3) : null;
                var value$5 = value$2.__typename;
                background_image_mobile = {
                  __typename: value$5,
                  value: value$4
                };
              } else {
                background_image_mobile = null;
              }
              var value$6 = value$1.background_image;
              var background_image;
              if (value$6 !== undefined) {
                var value$7 = value$6.value;
                var value$8 = value$7 !== undefined ? Js_array.map((function (value) {
                          if (value !== undefined) {
                            if (value.NAME === "UnspecifiedFragment") {
                              return {};
                            } else {
                              return Js_array.reduce(GraphQL_PPX.deepMerge, (function (prim) {
                                            return {};
                                          }), [Gql__Image__Fragment.$$Image.serialize(value.VAL.image)]);
                            }
                          } else {
                            return null;
                          }
                        }), value$7) : null;
                var value$9 = value$6.__typename;
                background_image = {
                  __typename: value$9,
                  value: value$8
                };
              } else {
                background_image = null;
              }
              var value$10 = value$1.background_colour;
              var background_colour;
              if (value$10 !== undefined) {
                var value$11 = value$10.value;
                var value$12 = value$11 !== undefined ? value$11 : null;
                var value$13 = value$10.__typename;
                background_colour = {
                  __typename: value$13,
                  value: value$12
                };
              } else {
                background_colour = null;
              }
              var value$14 = value$1.fontawesome_icon_class;
              var fontawesome_icon_class;
              if (value$14 !== undefined) {
                var value$15 = value$14.value;
                var value$16 = value$15 !== undefined ? value$15 : null;
                var value$17 = value$14.__typename;
                fontawesome_icon_class = {
                  __typename: value$17,
                  value: value$16
                };
              } else {
                fontawesome_icon_class = null;
              }
              var value$18 = value$1.icon;
              var icon;
              if (value$18 !== undefined) {
                var value$19 = value$18.value;
                var value$20 = value$19 !== undefined ? Js_array.map((function (value) {
                          if (value !== undefined) {
                            if (value.NAME === "UnspecifiedFragment") {
                              return {};
                            } else {
                              return Js_array.reduce(GraphQL_PPX.deepMerge, (function (prim) {
                                            return {};
                                          }), [Gql__Icon__Fragment.Icon.serialize(value.VAL.icon)]);
                            }
                          } else {
                            return null;
                          }
                        }), value$19) : null;
                var value$21 = value$18.__typename;
                icon = {
                  __typename: value$21,
                  value: value$20
                };
              } else {
                icon = null;
              }
              var value$22 = value$1.text_colour;
              var text_colour;
              if (value$22 !== undefined) {
                var value$23 = value$22.value;
                var value$24 = value$23 !== undefined ? Js_array.map((function (value) {
                          if (value === undefined) {
                            return null;
                          }
                          var value$1 = value.codename;
                          var codename = value$1 !== undefined ? value$1 : null;
                          var value$2 = value.__typename;
                          return {
                                  __typename: value$2,
                                  codename: codename
                                };
                        }), value$23) : null;
                var value$25 = value$22.__typename;
                text_colour = {
                  __typename: value$25,
                  value: value$24
                };
              } else {
                text_colour = null;
              }
              var value$26 = value$1.subtitle;
              var subtitle;
              if (value$26 !== undefined) {
                var value$27 = value$26.value;
                var value$28 = value$27 !== undefined ? value$27 : null;
                var value$29 = value$26.__typename;
                subtitle = {
                  __typename: value$29,
                  value: value$28
                };
              } else {
                subtitle = null;
              }
              var value$30 = value$1.title;
              var title;
              if (value$30 !== undefined) {
                var value$31 = value$30.value;
                var value$32 = value$31 !== undefined ? value$31 : null;
                var value$33 = value$30.__typename;
                title = {
                  __typename: value$33,
                  value: value$32
                };
              } else {
                title = null;
              }
              var value$34 = value$1.system;
              var value$35 = value$34.codename;
              var value$36 = value$34.id;
              var value$37 = value$34.__typename;
              var system = {
                __typename: value$37,
                id: value$36,
                codename: value$35
              };
              return {
                      __typename: "EnvironmentalImpactCardContentType",
                      system: system,
                      title: title,
                      subtitle: subtitle,
                      text_colour: text_colour,
                      icon: icon,
                      fontawesome_icon_class: fontawesome_icon_class,
                      background_colour: background_colour,
                      background_image: background_image,
                      background_image_mobile: background_image_mobile
                    };
            }), value$2) : null;
    var value$4 = value$1.__typename;
    environmental_impact_cards = {
      __typename: value$4,
      value: value$3
    };
  } else {
    environmental_impact_cards = null;
  }
  var value$5 = value.description;
  var description;
  if (value$5 !== undefined) {
    var value$6 = value$5.value;
    var value$7 = value$6 !== undefined ? value$6 : null;
    var value$8 = value$5.__typename;
    description = {
      __typename: value$8,
      value: value$7
    };
  } else {
    description = null;
  }
  var value$9 = value.title;
  var title;
  if (value$9 !== undefined) {
    var value$10 = value$9.value;
    var value$11 = value$10 !== undefined ? value$10 : null;
    var value$12 = value$9.__typename;
    title = {
      __typename: value$12,
      value: value$11
    };
  } else {
    title = null;
  }
  var value$13 = value.__typename;
  return {
          __typename: value$13,
          title: title,
          description: description,
          environmental_impact_cards: environmental_impact_cards
        };
}

function verifyArgsAndParse(_StatsTilesBlock, value) {
  return parse(value);
}

function verifyName(param) {
  
}

var StatsTilesBlock = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  verifyArgsAndParse: verifyArgsAndParse,
  verifyName: verifyName
};

var $$Image;

var Icon;

export {
  $$Image ,
  Icon ,
  StatsTilesBlock ,
}
/* query Not a pure module */
